(() => {
  const ownScript = document.currentScript || [...document.scripts].reverse().find((s) => /verdo-configurator\.js(?:\?|$)/.test(s.src));
  const currentSrc = ownScript?.src || '';
  const baseSrc = currentSrc.replace(/verdo-configurator\.js(?:\?.*)?$/, 'verdo-configurator-base.js');
  if (!baseSrc || baseSrc === currentSrc) return;

  const pathHandle = (() => {
    const match = location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  })();

  const ADORE = {
    'adore-signature-bedframe': { prices: { '160x200': 1490, '180x200': 1590 } },
    'adore-designbed-met-opbergruimte': { prices: { '160x200': 1390, '180x200': 1590 } },
    'adore-houston-met-opbergruimte': { prices: { '140x200': 1390, '160x200': 1490, '180x200': 1590 } },
    'adore-vana-met-opbergruimte': { prices: { '140x200': 1390, '160x200': 1490, '180x200': 1590 } },
    'adore-edira-met-opbergruimte': { prices: { '140x200': 1390, '160x200': 1490, '180x200': 1590 } },
    'adore-business-met-opbergruimte': { prices: { '160x200': 1490, '180x200': 1590 } },
    'adore-chique-met-opbergruimte': { prices: { '160x200': 1590, '180x200': 1790 } },
    'adore-melody-pearl-met-opbergruimte': { prices: { '140x200': 1390, '160x200': 1490, '180x200': 1590 } },
    'adore-element-pearl-met-opbergruimte': { prices: { '140x200': 1290, '160x200': 1390, '180x200': 1490 } },
    'adore-ruby-boucle-met-opbergruimte': { prices: { '140x200': 1290, '160x200': 1490, '180x200': 1590 } }
  };

  const HANDLE = Object.prototype.hasOwnProperty.call(ADORE, pathHandle) ? pathHandle : '';
  const config = HANDLE ? ADORE[HANDLE] : null;
  const money = (value) => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(Number(value) || 0);
  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const markAdorePicker = () => {
    if (!HANDLE) return null;
    const picker = document.querySelector(`variant-selects[data-product-handle="${CSS.escape(HANDLE)}"]`);
    if (!picker) return null;
    picker.dataset.bedConfigurator = 'true';
    picker.dataset.bedSlug = HANDLE;
    picker.dataset.adoreConfigurator = 'true';
    picker.dataset.nightstandMode = 'signature';
    picker.dataset.nightstandPrice = '199';
    picker.dataset.nightstandMax = '2';
    return picker;
  };

  const injectAdoreStyles = () => {
    if (document.getElementById('adore-configurator-fix')) return;
    const style = document.createElement('style');
    style.id = 'adore-configurator-fix';
    style.textContent = `
      variant-selects[data-adore-configurator="true"] .signature-color-swatches{margin-bottom:2.8rem!important;overflow:visible!important}
      variant-selects[data-adore-configurator="true"] .signature-color-swatches>.form__label,
      variant-selects[data-adore-configurator="true"] .signature-color-swatches>legend{display:flex!important;align-items:center!important;margin:0 0 .9rem!important;color:#0b1b35!important;font-size:1.55rem!important;font-weight:700!important}
      variant-selects[data-adore-configurator="true"] .signature-color-swatches input[type="radio"]+label{position:relative!important;display:inline-block!important;width:5.4rem!important;height:5.4rem!important;min-width:5.4rem!important;min-height:5.4rem!important;margin:0 1.5rem 2.5rem 0!important;padding:0!important;border:1px solid rgba(11,27,53,.28)!important;border-radius:50%!important;font-size:0!important;line-height:0!important;vertical-align:middle!important;box-shadow:0 2px 8px rgba(11,27,53,.08)!important;overflow:visible!important}
      variant-selects[data-adore-configurator="true"] .signature-color-swatches input[type="radio"]+label::after{content:attr(aria-label);position:absolute!important;top:calc(100% + .65rem)!important;left:50%!important;transform:translateX(-50%)!important;width:9rem!important;text-align:center!important;white-space:nowrap!important;font-size:1.2rem!important;line-height:1.25!important;font-weight:600!important;color:#0b1b35!important}
      variant-selects[data-adore-configurator="true"] .signature-color-swatches input[type="radio"]+label[data-signature-color="off-white"]{background:#f1ede5!important}
      variant-selects[data-adore-configurator="true"] .signature-color-swatches input[type="radio"]+label[data-signature-color="beige"]{background:#cbb79f!important}
      variant-selects[data-adore-configurator="true"] .signature-color-swatches input[type="radio"]+label[data-signature-color="grijs"]{background:#888a8d!important}
      variant-selects[data-adore-configurator="true"] .signature-color-swatches input[type="radio"]+label[data-signature-color="antraciet"]{background:#4b4c50!important}
      variant-selects[data-adore-configurator="true"] .signature-color-swatches input[type="radio"]+label[data-signature-color="cappuccino"]{background:#a38971!important}
      variant-selects[data-adore-configurator="true"] .signature-color-swatches input[type="radio"]:checked+label{outline:2px solid #0b1b35!important;outline-offset:3px!important;border-color:#fff!important}
      variant-selects[data-adore-configurator="true"] .signature-color-swatches .label-unavailable{display:none!important}
      variant-selects[data-adore-configurator="true"] .signature-mattress-block{margin-top:.1rem!important;margin-bottom:2.2rem!important}
      variant-selects[data-adore-configurator="true"] .signature-mattress-block .verdo-choice-grid{grid-template-columns:repeat(2,minmax(0,1fr))!important}
      variant-selects[data-adore-configurator="true"] .signature-mattress-block .verdo-choice{min-height:7.4rem!important}
      variant-selects[data-adore-configurator="true"] .adore-native-hidden{display:none!important}
      @media(max-width:749px){variant-selects[data-adore-configurator="true"] .signature-color-swatches input[type="radio"]+label{width:4.8rem!important;height:4.8rem!important;min-width:4.8rem!important;min-height:4.8rem!important;margin-right:1.25rem!important}variant-selects[data-adore-configurator="true"] .signature-mattress-block .verdo-choice-grid{grid-template-columns:1fr!important}}
    `;
    document.head.appendChild(style);
  };

  const findNativeGroup = (picker, labelText) => {
    const wanted = normalize(labelText);
    return [...picker.querySelectorAll('fieldset.product-form__input,.product-form__input--dropdown')].find((group) => {
      const heading = group.querySelector('.form__label,legend,label.form__label');
      return normalize(heading?.textContent).includes(wanted);
    }) || null;
  };

  const getNativeValue = (group) => {
    if (!group) return '';
    const select = group.querySelector('select');
    if (select) return select.options[select.selectedIndex]?.textContent?.trim() || select.value || '';
    return group.querySelector('input[type="radio"]:checked')?.value || '';
  };

  const chooseNativeValue = (group, wantedValue) => {
    if (!group) return false;
    const wanted = normalize(wantedValue);
    const select = group.querySelector('select');
    if (select) {
      const option = [...select.options].find((item) => normalize(item.value) === wanted || normalize(item.textContent) === wanted);
      if (!option) return false;
      select.value = option.value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    const radio = [...group.querySelectorAll('input[type="radio"]')].find((item) => normalize(item.value) === wanted);
    if (!radio) return false;
    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('input', { bubbles: true }));
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  };

  const addProperty = (productForm, name, value) => {
    if (!productForm) return;
    let input = productForm.querySelector(`input[data-signature-property="${CSS.escape(name)}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${name}]`;
      input.dataset.signatureProperty = name;
      productForm.appendChild(input);
    }
    input.value = value;
  };

  const getBasePrice = (size) => {
    const exact = String(size || '').replace(/\s+/g, '');
    return config?.prices?.[exact] ?? Object.values(config?.prices || {})[0] ?? 0;
  };

  const applyAdore = () => {
    const picker = markAdorePicker();
    if (!picker || !config) return false;
    injectAdoreStyles();

    const productInfo = picker.closest('product-info') || document;
    const productForm = productInfo.querySelector('form[action*="/cart/add"]');
    const sizeGroup = picker.querySelector('.verdo-size-picker') || findNativeGroup(picker, 'afmeting');
    const colorGroup = picker.querySelector('.bed-color-picker-native') || findNativeGroup(picker, 'kleur');
    const mattressNative = findNativeGroup(picker, 'matras');
    const flow = productInfo.querySelector('.verdo-options-flow');
    if (!sizeGroup || !colorGroup || !mattressNative || !flow) return false;

    picker.dataset.maintenancePackageMerged = 'true';

    const colorHeading = colorGroup.querySelector('.form__label,legend,label.form__label');
    if (colorHeading) colorHeading.innerHTML = '<span class="verdo-step-number">2</span><span>Kleur/Stof</span>';
    colorGroup.classList.add('signature-color-swatches');
    colorGroup.querySelectorAll('input[type="radio"]').forEach((input) => {
      const label = input.id ? colorGroup.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
      if (!label) return;
      const value = normalize(input.value);
      let swatch = value.replace(/\s+/g, '-');
      if (value.includes('off')) swatch = 'off-white';
      else if (value.includes('antr')) swatch = 'antraciet';
      else if (value.includes('capp')) swatch = 'cappuccino';
      else if (value.includes('grijs')) swatch = 'grijs';
      else if (value.includes('beige')) swatch = 'beige';
      label.dataset.signatureColor = swatch;
      label.title = input.value;
      label.setAttribute('aria-label', input.value);
    });

    mattressNative.classList.add('adore-native-hidden');
    mattressNative.setAttribute('aria-hidden', 'true');

    let mattressBlock = picker.querySelector('[data-signature-mattress-block]');
    if (!mattressBlock) {
      mattressBlock = document.createElement('section');
      mattressBlock.className = 'verdo-config-block signature-mattress-block';
      mattressBlock.dataset.signatureMattressBlock = 'true';
      mattressBlock.innerHTML = `
        <div class="verdo-step-heading"><span class="verdo-step-number">3</span><span>Matras</span></div>
        <div class="verdo-choice-grid">
          <button type="button" class="verdo-choice" data-signature-mattress="Zonder matras"><strong>Zonder matras</strong><small>€0,00</small></button>
          <button type="button" class="verdo-choice" data-signature-mattress="Met matras"><strong>Met matras</strong><small data-signature-mattress-surcharge>+ €600,00</small></button>
        </div>`;
      colorGroup.insertAdjacentElement('afterend', mattressBlock);
    }

    const getSize = () => sizeGroup.querySelector('input[type="radio"]:checked')?.value || sizeGroup.querySelector('select')?.value || Object.keys(config.prices)[0];
    const selectedMattress = () => normalize(getNativeValue(mattressNative)).includes('met matras');

    const updateSizePrices = () => {
      sizeGroup.querySelectorAll('input[type="radio"]').forEach((input) => {
        const label = input.id ? sizeGroup.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
        const priceEl = label?.querySelector('.verdo-size-price');
        if (priceEl) priceEl.textContent = money(getBasePrice(input.value));
      });
    };

    const renderMattress = () => {
      const selected = selectedMattress() ? 'Met matras' : 'Zonder matras';
      mattressBlock.querySelectorAll('[data-signature-mattress]').forEach((button) => {
        const active = button.dataset.signatureMattress === selected;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const surcharge = mattressBlock.querySelector('[data-signature-mattress-surcharge]');
      if (surcharge) surcharge.textContent = '+ €600,00';
    };

    if (!mattressBlock.dataset.bound) {
      mattressBlock.dataset.bound = 'true';
      mattressBlock.addEventListener('click', (event) => {
        const button = event.target.closest('[data-signature-mattress]');
        if (!button) return;
        chooseNativeValue(mattressNative, button.dataset.signatureMattress);
        renderMattress();
        setTimeout(applyAdore, 50);
        setTimeout(applyAdore, 180);
      });
    }

    const nightstand = flow.querySelector('[data-verdo-step="nightstand"]');
    const duvet = flow.querySelector('[data-verdo-step="duvet"]');
    const montage = flow.querySelector('[data-verdo-step="montage"]');
    const protect = flow.querySelector('[data-verdo-step="protect"]');
    const service = flow.querySelector('[data-verdo-step="service"]');
    if (!nightstand || !duvet || !montage) return false;

    if (protect) { protect.style.setProperty('display', 'none', 'important'); protect.setAttribute('aria-hidden', 'true'); }
    if (service) { service.style.setProperty('display', 'none', 'important'); service.setAttribute('aria-hidden', 'true'); }

    const nightHeading = nightstand.querySelector('.verdo-step-heading span:last-child');
    if (nightHeading) nightHeading.textContent = 'Nachtkastje(s)';
    const nightOne = nightstand.querySelector('[data-verdo-choice="nightstand:one"] small');
    const nightTwo = nightstand.querySelector('[data-verdo-choice="nightstand:two"] small');
    if (nightOne) nightOne.textContent = '+ €199,00';
    if (nightTwo) nightTwo.textContent = '+ €398,00';

    let maintenance = flow.querySelector('[data-signature-step="maintenance"],[data-verdo-step="maintenance"]');
    if (!maintenance) {
      maintenance = document.createElement('section');
      maintenance.className = 'verdo-config-block';
      maintenance.dataset.signatureStep = 'maintenance';
      maintenance.innerHTML = `
        <div class="verdo-step-heading"><span class="verdo-step-number">6</span><span>Onderhoudspakket</span></div>
        <div class="verdo-choice-grid">
          <button type="button" class="verdo-choice is-selected" data-signature-maintenance="exclusive"><strong>Exclusief</strong><small>€0,00</small></button>
          <button type="button" class="verdo-choice" data-signature-maintenance="inclusive"><strong>Inclusief onderhoudspakket + 5 jaar garantie</strong><small>+ €99,95</small></button>
        </div>`;
      flow.appendChild(maintenance);
    }
    const maintenanceLabel = maintenance.querySelector('[data-signature-maintenance="inclusive"] strong,[data-maintenance-choice="inclusive"] strong');
    if (maintenanceLabel) maintenanceLabel.textContent = 'Inclusief onderhoudspakket + 5 jaar garantie';

    let disposal = flow.querySelector('[data-signature-step="disposal"]');
    if (!disposal) {
      disposal = document.createElement('section');
      disposal.className = 'verdo-config-block';
      disposal.dataset.signatureStep = 'disposal';
      disposal.innerHTML = `
        <div class="verdo-step-heading"><span class="verdo-step-number">8</span><span>Oude bed meenemen &amp; afvoeren</span></div>
        <div class="verdo-choice-grid">
          <button type="button" class="verdo-choice is-selected" data-signature-disposal="no"><strong>Nee</strong><small>€0,00</small></button>
          <button type="button" class="verdo-choice" data-signature-disposal="yes"><strong>Ja</strong><small>+ €125,00</small></button>
        </div>`;
      flow.appendChild(disposal);
    }

    const stateKey = `nachtcomfort-adore-extras:${picker.dataset.productId || HANDLE}`;
    let state = { maintenance: 'exclusive', disposal: 'no' };
    try { state = Object.assign(state, JSON.parse(sessionStorage.getItem(stateKey) || '{}')); } catch (_) {}
    const saveState = () => { try { sessionStorage.setItem(stateKey, JSON.stringify(state)); } catch (_) {} };

    const renderMaintenance = () => {
      maintenance.querySelectorAll('[data-signature-maintenance],[data-maintenance-choice]').forEach((button) => {
        const value = button.dataset.signatureMaintenance || button.dataset.maintenanceChoice;
        const active = value === state.maintenance;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      addProperty(productForm, 'Onderhoudspakket', state.maintenance === 'inclusive' ? 'Inclusief + €99,95' : 'Exclusief');
    };

    const renderDisposal = () => {
      disposal.querySelectorAll('[data-signature-disposal]').forEach((button) => {
        const active = button.dataset.signatureDisposal === state.disposal;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      addProperty(productForm, 'Oude bed meenemen & afvoeren', state.disposal === 'yes' ? 'Ja + €125,00' : 'Nee');
    };

    if (!maintenance.dataset.signatureBound) {
      maintenance.dataset.signatureBound = 'true';
      maintenance.addEventListener('click', (event) => {
        const button = event.target.closest('[data-signature-maintenance],[data-maintenance-choice]');
        if (!button) return;
        const value = button.dataset.signatureMaintenance || button.dataset.maintenanceChoice;
        state.maintenance = value === 'inclusive' ? 'inclusive' : 'exclusive';
        flow.querySelector(`[data-verdo-choice="service:${state.maintenance}"]`)?.click();
        flow.querySelector('[data-verdo-choice="protect:none"]')?.click();
        renderMaintenance();
        saveState();
        setTimeout(updateTotal, 0);
      });
    }

    if (!disposal.dataset.signatureBound) {
      disposal.dataset.signatureBound = 'true';
      disposal.addEventListener('click', (event) => {
        const button = event.target.closest('[data-signature-disposal]');
        if (!button) return;
        state.disposal = button.dataset.signatureDisposal === 'yes' ? 'yes' : 'no';
        renderDisposal();
        saveState();
        setTimeout(updateTotal, 0);
      });
    }

    const setFlowNumber = (section, number) => {
      const numberEl = section?.querySelector('[data-flow-number],.verdo-step-number');
      if (numberEl) numberEl.textContent = String(number);
    };
    setFlowNumber(nightstand, 4);
    setFlowNumber(duvet, 5);
    setFlowNumber(maintenance, 6);
    setFlowNumber(montage, 7);
    setFlowNumber(disposal, 8);

    flow.appendChild(nightstand);
    flow.appendChild(duvet);
    flow.appendChild(maintenance);
    flow.appendChild(montage);
    flow.appendChild(disposal);
    if (protect) flow.appendChild(protect);
    if (service) flow.appendChild(service);

    const quantity = productInfo.querySelector('.product-form__quantity');
    const quantityLabel = quantity?.querySelector('.quantity__label,label');
    if (quantityLabel) quantityLabel.textContent = '9. Aantal';

    const totalBar = productInfo.querySelector('.verdo-sticky-total');
    const buy = productInfo.querySelector('.product-form__buttons');
    if (totalBar) {
      const small = totalBar.querySelector('small');
      if (small) small.textContent = '10. Totaalprijs';
      if (buy?.parentNode && totalBar.nextElementSibling !== buy) buy.parentNode.insertBefore(totalBar, buy);
    }

    const selectedNightstandAmount = () => {
      if (nightstand.querySelector('[data-verdo-choice="nightstand:two"].is-selected')) return 398;
      if (nightstand.querySelector('[data-verdo-choice="nightstand:one"].is-selected')) return 199;
      return 0;
    };
    const getBedPrice = () => getBasePrice(getSize()) + (selectedMattress() ? 600 : 0);

    function updateTotal() {
      const total = getBedPrice() + selectedNightstandAmount() + (state.maintenance === 'inclusive' ? 99.95 : 0) + (state.disposal === 'yes' ? 125 : 0);
      const output = totalBar?.querySelector('[data-verdo-total]');
      if (output) output.textContent = money(total);
    }

    updateSizePrices();
    renderMattress();
    renderMaintenance();
    renderDisposal();
    updateTotal();

    if (!picker.dataset.signatureExactBound) {
      picker.dataset.signatureExactBound = 'true';
      picker.addEventListener('change', () => {
        setTimeout(() => { updateSizePrices(); renderMattress(); updateTotal(); }, 0);
        setTimeout(updateTotal, 100);
      });
      flow.addEventListener('click', () => {
        setTimeout(updateTotal, 0);
        setTimeout(updateTotal, 100);
      });
    }

    return true;
  };

  const scheduleAdore = () => {
    if (!HANDLE) return;
    [0, 100, 250, 500, 900, 1500].forEach((delay) => setTimeout(applyAdore, delay));
  };

  markAdorePicker();
  const baseScript = document.createElement('script');
  baseScript.src = baseSrc + (baseSrc.includes('?') ? '&' : '?') + 'ncbase=' + Date.now();
  baseScript.async = false;
  baseScript.onload = scheduleAdore;
  document.head.appendChild(baseScript);

  if (HANDLE && !window.__nachtcomfortAdoreConfiguratorBound) {
    window.__nachtcomfortAdoreConfiguratorBound = true;
    document.addEventListener('DOMContentLoaded', () => { markAdorePicker(); scheduleAdore(); });
    document.addEventListener('shopify:section:load', () => { markAdorePicker(); scheduleAdore(); });
    document.addEventListener('shopify:section:select', () => { markAdorePicker(); scheduleAdore(); });
    document.addEventListener('change', (event) => {
      if (!event.target.closest(`variant-selects[data-product-handle="${CSS.escape(HANDLE)}"]`)) return;
      scheduleAdore();
    });
  }
})();
